// extracted by mini-css-extract-plugin
export default {"title":"MainTitle_title__K0U92"};